import { Request,BaseApiUrl } from "./api";
// 工程模块
// 列表
export const getSupplierListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/Supplier/get`, { params: params });
};
//编辑
export const editSupplier = (params) => {
  return Request.post(`${BaseApiUrl}/api/Supplier/put`, params);
};
//新增
export const addSupplier = (params) => {
  return Request.post(`${BaseApiUrl}/api/Supplier/post`, params);
};
//批量删除
export const batchDeleteSupplier = (params) => {
  return Request.post(`${BaseApiUrl}/api/Supplier/BatchDelete`, params);
};
// export const batchDeleteSupplier = (params) => {
//   return Request.delete(`${BaseApiUrl}/api/Supplier/BatchDelete`, {
//     data: params,
//     headers: {
//       "Content-Type": "application/json-patch+json",
//     },
//   });
// };